import { LocaleData, LocaleConfig } from '../types';

export const config: LocaleConfig = {
    id: 'eo',
    fullName: 'Esperanto',
    nativeName: 'Esperanto',
    direction: 'ltr'
};

const translations: LocaleData = {
    title: "ArgVoid",
    landing_title: "Venas Io Mirinda",
    landing_subtitle: "ArgVoid estas studo pri aplikaĵo kaj lud-disvolvado. Restu agordita, novaj aferoj baldaŭ venos!",
    select_language: "Elektu Lingvon",
    search_placeholder: "Serĉi lingvojn...",
    terms_title: "Servokondiĉoj",
    policy_title: "Privateca Politiko",
    cookies_title: "Politiko pri Kuketoj",
    terms_content: `
        <strong>1. Akcepto de Kondiĉoj</strong><br>
        Alirante ArgVoid, ĉi tiuj Servokondiĉoj estas akceptitaj. Se ĉi tiuj kondiĉoj ne estas konsentitaj, la servo ne estu uzata.<br><br>

        <strong>2. Platformuzo</strong><br>
        ArgVoid kaj ĝiaj aplikoj estas provizitaj "kiel estas" por informaj kaj kreivaj celoj. La servo devas esti uzata nur por laŭleĝaj celoj.<br><br>

        <strong>3. Malpermesita Konduto</strong><br>
        Ekspluatado de la vundeblecoj de la retejo, spamado aŭ provi neaŭtorizitan aliron al la infrastrukturo estas strikte malpermesita.<br><br>

        <strong>4. Malgarantio</strong><br>
        La platformo kaj servoj povas esti modifitaj iam ajn sen avizo. Neniu garantio estas donita pri la funkciado aŭ havebleco de la servo.
    `,
    policy_content: `
        <strong>1. Informo-Kolekto</strong><br>
        La platformo ne postulas uzantan aŭtentigon aŭ kreadon de konto nuntempe. Neniuj personaj identigaj informoj (kiel nomoj aŭ retpoŝtaj adresoj) estas aktive kolektitaj de vizitantoj.<br><br>

        <strong>2. Uzado-datumoj</strong><br>
        Bazaj, anonimigitaj analizoj povas esti kolektitaj por kompreni retejan trafikon kaj plibonigi la aplikojn. Ĉi tiuj datumoj ne estas ligitaj al individuaj uzantidentoj.<br><br>

        <strong>3. Triaj Servoj</strong><br>
        Triaj provizantoj povas esti uzataj por gastigado kaj analizaj servoj. La privatecaj praktikoj de ĉi tiuj respektivaj provizantoj regas la anonimajn datumojn prilaboritajn sur ilia infrastrukturo.<br><br>

        <strong>4. Sekureco de datumoj</strong><br>
        Raciaj sekurecaj mezuroj estas efektivigitaj por protekti la platformon. Tamen neniu metodo de transdono per la Interreto estas tute sekura.<br><br>
    `,
    cookies_content: `
        <strong>1. Kio estas Kuketoj kaj Loka Stokado?</strong><br>
        Kuketoj kaj retumila loka stokado estas malgrandaj datumdosieroj konservitaj en la aparato por memori agordajn preferojn tra vizitoj.<br><br>

        <strong>2. Uzado Celo</strong><br>
        Retumilo LocalStorage estas uzata strikte por konservi agordajn agordojn, kiel:<br>
        - Lingvaj preferoj<br>
        - Agordo de uzantinterfaco (ekz. aranĝo aŭ temo-agordoj) <br>
        - Provizora aplikaĵa kaŝmemoro<br><br>

        <strong>3. Neniu Spurado</strong><br>
        Kuketoj kaj loka stokado ne estas uzataj por reklamado aŭ por spurado de triaj celoj. Ĉiuj konservitaj datumoj estas strikte por la kerna funkcio de la platformo.<br><br>

        <strong>4. Kontrolo</strong><br>
        Retumilo-datumoj povas esti forigitaj iam ajn per la retumilo-agordoj, kiuj restarigos iujn lokajn agordojn.
    `,
    cookie_consent_text: "Ni uzas bazajn kuketojn por certigi, ke la retejo funkcias ĝuste, kiel teni vian seancon aktiva, konservi vian lingvan preferon kaj aliajn kutimajn agordojn.",
    read_policy: "Legu Politikon pri Kuketoj",
    support_title: "Kontaktu Subtenon",
    support_subject_label: "Subjekto",
    support_message_label: "Mesaĝo",
    support_submit_button: "Sendu Mesaĝon",
    support_hint: "Noto: Ĉi tio malfermos vian defaŭltan retpoŝtan aplikaĵon por sendi la mesaĝon.",
    support_success_msg: "Malfermante vian retpoŝtan apon...",
    support_error_msg: "Malsukcesis sendi mesaĝon. Bonvolu provi denove poste.",
    explorer_title: "Esploristo",
    history_title: "Historio",
    animation_title: "Animacio",
    config_title: "Agordo",
    tool_mouse: "Elektu (Ctrl+M)",
    tool_brush: "Peniko (Ctrl+B)",
    tool_brush_mode: "Ŝaltigi reĝimon (solida/klara)",
    tool_eraser: "Skrapgumo (Ctrl+E)",
    tool_brush_size: "Alĝustigu Peniko Grandecon",
    tool_bucket: "Plenigu (Ctrl+F)",
    tool_eyedropper: "Eyedropper",
    tool_grid: "Krado (Ktrl+Shift+B)",
    tool_rotate: "Rotacii (Ctrl+Majsku+R)",
    tool_flip_h: "Turnu H (Ktrl+Shift+H)",
    tool_flip_v: "Turnu V (Ktrl+Shift+V)",
    tool_transpose: "Transmeti (Ktrl+Majsku+T)",
    label_width: "Larĝo",
    label_height: "Alteco",
    label_frames: "Nombro de Kadroj",
    label_animation: "Animacia Stilo",
    label_background_color: "Fona Koloro",
    label_interval: "Intervalo",
    tool_anim_config: "Animacia Agordo",
    label_new_width: "Nova Larĝo",
    label_new_height: "Nova Alteco",
    label_apply: "Apliki",
    label_colors: "Koloroj",
    label_size: "Grandeco",
    label_tolerance: "Toleremo",
    val_horizontal: "Horizontala",
    val_vertical: "Vertikala",
    val_sequence: "Sekvenco",
    val_bounce: "Resalto",
    val_random: "Hazarda",
    val_solid: "Solida",
    val_clear: "Klara",
    action_add_sheet: "Nova Folio",
    action_import: "Importi",
    action_export: "Eksporto",
    action_sort_projects: "Ordigi",
    sort_date_old: "Plej malnova Unue",
    sort_date_new: "Plej Nova Unue",
    sort_name_az: "Nomo (A-Z)",
    sort_name_za: "Nomo (Z-A)",
    action_new_sprite: "Nova Sprite",
    action_new_project: "Nova Projekto",
    modal_save_all_title: "Konservu Ĉiuj Ŝanĝoj",
    modal_save_all_desc: "Elektu la aktivaĵojn por konservi:",
    modal_save_selected: "Konservu Elektitajn",
    action_saved: "Savita",
    modal_create_sprite_title: "Kreu Novan Sprite",
    modal_create_project_title: "Krei Novan Projekton",
    modal_add_sheet_title: "Aldonu Novan Folion",
    modal_rename_sheet_title: "Alinomi Folion",
    modal_rename_sprite_title: "Alinomi Sprite",
    modal_delete_sprite_title: "Forigi Sprite",
    modal_delete_project_title: "Forigi Projekton",
    modal_delete_sheet_title: "Forigi Folion",
    placeholder_sprite_name: "Nomo",
    placeholder_project_name: "Nomo",
    placeholder_sheet_name: "Nomo",
    placeholder_new_name: "Nova Nomo",
    action_create: "Krei",
    action_add: "Aldoni",
    action_rename: "Alinomi",
    action_duplicate: "Duobligi",
    action_delete: "Forigi",
    action_cancel: "Nuligi",
    confirm_delete_sprite: "Ĉu vi certas, ke vi volas forigi ĉi tiun spritaĵon?",
    confirm_delete_project: "Ĉu vi certas, ke vi volas forigi ĉi tiun projekton? Ĉiuj spritoj estos forigitaj.",
    confirm_delete_sheet: "Ĉu vi certas, ke vi volas forigi ĉi tiun folion?",
    err_select_sprite: "Bonvolu unue elekti spriteton.",
    err_select_project: "Bonvolu unue elekti projekton.",
    err_name_empty: "Nomo ne povas esti malplena.",
    err_sprite_exists: "Sprite kun tiu nomo jam ekzistas.",
    err_project_exists: "Projekto kun tiu nomo jam ekzistas.",
    err_no_content: "Neniu enhavo por konservi.",
    err_no_changes: "Neniuj ŝanĝoj por konservi.",
    err_delete_last_sheet: "Ne povas forigi la lastan folion.",
    err_extract_frames: "Ne eblis ĉerpi iujn ajn kadrojn.",
    err_indexeddb: "Malsukcesis konservi loke. Via retumilo eble ne subtenas IndexedDB.",
    msg_upload_success: "Sukcesa alŝuto: {0}",
    msg_upload_failed: "Alŝuto malsukcesis: {0}",
    msg_save_success: "Konservu sukcese.",
    msg_saving: "Konservante...",
    msg_multi_save_result: "Konservitaj {0} valoraĵoj. {1} malsukcesoj.",
    menu_title: "Menuo",
    menu_save: "Konservu",
    menu_save_all: "Konservu Ĉion",
    menu_support: "Kontaktu Subtenon",
    label_local_storage: "Loka Stokado",
    label_sign_in: "Ensalutu",
    modal_export_title: "Eksporti Sprite",
    label_filename: "Dosiernomo",
    label_format: "Formato",
    action_export_confirm: "Eksporto",
};

export default translations;
